/**
 * Keys of additional properties of dataset resources
 */
enum DatasetResourceAdditionalPropertiesKeys {
  'lastRefreshTime' = 'lastRefreshTime',
}

export { DatasetResourceAdditionalPropertiesKeys };
